// eslint-disable-next-line jsx-a11y/anchor-is-valid
import * as React from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import ConfirmEmail from "../pages/ConfirmEmaill/confirmEmail";
import CookieBanner from "../pages/CookiePage/CookiePage";
import HomePage from "../pages/Home/HomePage";
import PrivacyPage from "../pages/PrivacyPage/PrivacyPage";
import ResetPasswordPage from "../pages/ResetPassword/resetPassword";

function Router() {
    return (
        <BrowserRouter>
            <div>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/confirmEmail" element={<ConfirmEmail />} />
                    <Route path="/resetPassword" element={<ResetPasswordPage />} />
                    <Route path="/Cookie" element={<CookieBanner />} />
                    <Route path="/Privacy" element={<PrivacyPage />} />
                </Routes>
                <div style={{ position: "absolute", bottom: 10, width: "100%", textAlign: 'center' }}>
                    <span>© 2022
                         <a href={`${window.location.origin + `/Privacy`}`} target={'_blank'} rel="noreferrer"> TERM OF USE & PRIVACY NOTICES</a>
                         &nbsp;&
                         <a href={`${window.location.origin + `/Cookie`}`} target={'_blank'} rel="noreferrer"> COOKIES</a>
                     </span>
                </div>

            </div>
        </BrowserRouter>
    )

}

export default Router;